import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import CheckboxSVG from "segments/desktop/core-components/product-card/checkbox-icon";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { StyledMobileCard } from "./mobile-card.scss";
const MobileCard = ({ useCases, cardAsset, tag })=>/*#__PURE__*/ _jsxs(StyledMobileCard, {
        className: "mobile-card",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "picture-wrapper",
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    src: cardAsset
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card-content",
                children: [
                    /*#__PURE__*/ _jsx(Paragraph, {
                        body: tag === null || tag === void 0 ? void 0 : tag.tagText
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "use-cases-wrapper",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.map(({ useCase })=>/*#__PURE__*/ _jsxs("div", {
                                className: "use-case",
                                children: [
                                    /*#__PURE__*/ _jsx(CheckboxSVG, {}),
                                    useCase
                                ]
                            }))
                    })
                ]
            })
        ]
    });
export default MobileCard;
